<template>
  <div class="worker-container" :class="{ selected: selected }">
    <div class="heaven">
      <div class="avatar" @click="onDetailed()">
        <v-avatar>
          <img v-if="worker.avatarURL" class="avatar" :src="(worker.avatarURL)" />
          <v-icon v-else class="initials">{{ initials }}</v-icon>
        </v-avatar>
      </div>
      <div class="name-country">
        <div class="name" @click="onDetailed()">{{ worker.firstName }} {{ worker.lastName }}</div>
        <div class="country">{{ companyName }}, {{ worker.country }}</div>
      </div>
      <div class="heaven-checkbox">
        <custom-checkbox :value="selected" color="cold-marine" @input="onChecked" />
      </div>
    </div>
    <div class="hell">
      <div class="hours-rate inline-block">
        <div class="hell-value">${{ worker.hourRate || 0 }}</div>
        <div class="hell-title">
          {{ $t('newProject.worker.hourly.rate') }}
        </div>
      </div>
      <div class="jobs inline-block">
        <div class="hell-value">
          {{ worker.amountOfJobs || 0 }}
        </div>
        <div class="hell-title">
          {{ $t('newProject.worker.jobs') }}
        </div>
      </div>
      <div class="experience inline-block">
        <div class="hell-value">{{ worker.experience || 0 }} {{ $t('newProject.worker.years') }}</div>
        <div class="hell-title">
          {{ $t('newProject.worker.experience') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import store from '@/store';
import { LOAD_WORKER_DETAILS } from '@/store/user/actionTypes';
import CustomCheckbox from '@/components/common/CustomCheckbox.vue';

export default {
  name: 'NewProjectWorker',
  components: { CustomCheckbox },
  props: {
    worker: Object,
    selected: Boolean,
  },
  computed: {
    ...mapGetters(['workerDetails']),
    initials() {
      return `${this.worker.firstName[0].toUpperCase()}${this.worker.lastName[0].toUpperCase()}`;
    },
    companyName() {
      if (this.worker.isFreelancer) {
        return this.$t('freelancer');
      }
      return this.worker.company?.name;
    },
  },
  methods: {
    onChecked() {
      const data = {
        id: this.worker.id,
        name: `${this.worker.firstName} ${this.worker.lastName}`,
      };
      this.$emit('clicked', data);
    },
    async onDetailed() {
      await store.dispatch(LOAD_WORKER_DETAILS, { id: this.worker.id });
      this.$emit('detailed', this.workerDetails);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.worker-container {
  box-sizing: border-box;
  height: rem(115);
  width: rem(272);
  border: 1px solid rgba(159, 165, 180, 0.5);
  border-radius: $radius-md;
  background-color: var(--bg-primary);

  &.selected {
    border: 2px solid var(--brand-primary);
  }

  &:hover {
    box-sizing: border-box;
    border: 1px solid var(--brand-primary);
    box-shadow: 0 0 rem(7) 0 rgba(36, 89, 213, 0.3);
  }

  .heaven {
    height: 50%;
    border-bottom: 1px rgba(207, 210, 217, 0.25) solid;

    margin-left: $space-4;
    margin-right: $space-4;

    .avatar {
      cursor: pointer;
      height: rem(34);
      width: rem(34);
      display: inline-block;
      position: relative;
      bottom: rem(11);

      img.avatar {
        width: rem(34);
        height: rem(34);
        display: inline-block;
        margin-left: 0;
        bottom: 0;
      }

      ::v-deep .v-avatar {
        min-width: rem(34) !important;
        width: rem(34) !important;
        min-height: rem(34) !important;
        height: rem(34) !important;
      }

      .initials {
        background-color: rgba(14, 31, 51, 0.15);
        border-radius: rem(50);
        color: var(--text-secondary);
        display: block;
        height: rem(34);
        width: rem(34);
        font-size: $font-size-base;
        font-family: $font-family-regular;
        padding-top: $space-2;
      }
    }

    .name-country {
      margin-left: $space-2;
      height: rem(34);
      width: rem(103);
      display: inline-block;
      position: relative;
      text-transform: capitalize;

      .name {
        cursor: pointer;
        height: rem(20);
        width: rem(150);
        color: var(--text-primary);
        font-size: $font-size-base;
        font-weight: bold;
        letter-spacing: 0;
        line-height: rem(20);
        overflow: hidden;
        text-overflow: ellipsis;
        &:hover {
          color: var(--brand-primary);
        }
      }

      .country {
        height: rem(12);
        width: rem(210);
        color: var(--text-tertiary);
        font-size: $font-size-sm;
        letter-spacing: 0;
        line-height: rem(12);
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .heaven-checkbox {
      display: inline-block;
      position: relative;
      left: rem(70);
      bottom: rem(18);
      margin-top: rem(31);
      margin-right: rem(5);
      .checkbox-container{
        right: $space-2;
      }
    }
  }

  .hell {
    height: 50%;
    margin-left: $space-4;
    margin-right: $space-4;

    .inline-block {
      display: inline-block;
      height: 100%;
      width: 33%;
      margin-top: $space-3;
    }

    .hell-title {
      height: rem(14);
      color: var(--text-tertiary);
      font-size: $font-size-sm;
      letter-spacing: 0;
      line-height: rem(14);
      text-align: left;
    }

    .hell-value {
      height: rem(14);
      color: var(--text-primary);
      font-size: $font-size-sm;
      font-weight: 900;
      letter-spacing: 0;
      line-height: rem(14);
      text-align: left;
    }
  }
}
</style>
